import { catalogosSelector } from "features/Inventario/redux/selectors/catalogosSelector"
import { getCatalogo } from "features/Inventario/redux/slices/catalogosSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import CatalogoForm from "../NewCatalogo/CatalogoForm"

const EditCatalogo = () => {
  const [render, setRender] = useState(false)
  const params = useParams()
  const dispatch = useDispatch()

  const { catalogo, fetchingCatalogo } = useSelector(catalogosSelector)

  useEffect(() => {
    dispatch(getCatalogo(params.id))
    setRender(true)
  }, [params, dispatch])

  if (!render || fetchingCatalogo) return null

  return (
    <CatalogoForm
      // @ts-expect-error TS(2322): Type '{ catalogo: $TSFixMe; isEditing: true; catalogoId...
      catalogo={catalogo}
      isEditing
      catalogoId={params.id}
      // t={t}
    />
  )
}

export default EditCatalogo
